export const semanticTokens = {
    colors: {},
};
